import { Component, Input } from '@angular/core';

@Component({
  selector: 'fe-warranty',
  templateUrl: './warranty.component.html',
  styleUrls: ['./warranty.component.scss']
})
export class WarrantyComponent {

  @Input() isLite = false;
}
